"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateOrderNew = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../classes/com/tmpls");
const StatePaged_1 = require("../../classes/states/abstracts/StatePaged");
const BreadCrumb_1 = require("../../classes/models/BreadCrumb");
const Helper_1 = require("../../classes/Helper");
const models_1 = require("../../classes/api/classes/models");
const StateCart_1 = require("./StateCart");
const CartController_1 = require("../controllers/CartController");
const GUIControllerPM_1 = require("../controllers/GUIControllerPM");
const ClassesTags_1 = require("../../classes/ClassesTags");
const AppPM_1 = require("../AppPM");
class StateOrderNew extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageOrderNew, "Новый заказ", false);
        this._deliveryTariff = "";
        this._deliveryAddress = "";
        const ctrl = this.page.ctrls;
        ctrl.cmpCartTotal.ctrls.btnSubmit.onclick = () => {
            if (!this.app.auth.user) {
                this.app.auth.authAsync();
                return;
            }
            this._tryCreateNewOrderAsync();
        };
        ctrl.btnGetDelivery.onclick = () => {
            ctrl.btnGetDelivery.addClass(ClassesTags_1.ClassesTags.Active);
            ctrl.btnGetPickUp.removeClass(ClassesTags_1.ClassesTags.Active);
            ctrl.blockGetDelivery.show();
            ctrl.blockGetPickUp.hide();
            this._resetDeliveryDataAsync();
        };
        ctrl.btnGetPickUp.onclick = () => {
            ctrl.btnGetDelivery.removeClass(ClassesTags_1.ClassesTags.Active);
            ctrl.btnGetPickUp.addClass(ClassesTags_1.ClassesTags.Active);
            ctrl.blockGetDelivery.hide();
            ctrl.blockGetPickUp.show();
            this._resetDeliveryDataAsync();
        };
        this._handlerRefresh = () => { this._fillCartTotalAsync(); };
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this._cartCtrl = this.app.getInst(CartController_1.CartController);
            this.app.getInst(GUIControllerPM_1.GUIControllerPM).setBreadcrumbs([new BreadCrumb_1.BreadCrumb("Главная", "/"), new BreadCrumb_1.BreadCrumb('Корзина', `/${StateCart_1.StateCart.StateName}`)]);
            if (this.app.auth.user) {
                this.page.ctrls.iName.value = this.app.auth.user.name;
                this.page.ctrls.iPhone.value = this.app.auth.phone;
                this.page.ctrls.iEmail.value = this.app.auth.email;
                this.page.ctrls.iPhone.disable();
            }
            const tariffBook = yield this.app.cache.getTariffBookAsync();
            if (!tariffBook)
                return gs.StateRunResultEnum.Failed;
            this._fillCartTotalAsync();
            this._fillDeliveryOptions(tariffBook);
            return _super.start.call(this);
        });
    }
    afterStart(args) {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this, args);
            this._cartCtrl.onCartChanged.addHandler(this._handlerRefresh);
            yield this._loadMapAsync();
        });
    }
    stop() {
        const _super = Object.create(null, {
            stop: { get: () => super.stop }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this._cartCtrl.onCartChanged.removeHandler(this._handlerRefresh);
            _super.stop.call(this);
        });
    }
    _loadMapAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this._map = new globalThis.ymaps.Map(this.page.ctrls.blockMap.el, { center: [45.035470, 38.975313], zoom: 10, controls: [] }, { suppressMapOpenBlock: true, suppressObsoleteBrowserNotifier: true });
            const pinStore = new globalThis.ymaps.Placemark([45.013829, 38.93633], { balloonContent: 'Магазин' });
            this._map.geoObjects.add(pinStore);
            let pinDelivery;
            //     map.events.add('click', async (e) => {
            //     const coords = e.get('coords');
            //     // Если уже есть пин — просто перемещаем
            //     if (pinDelivery) {
            //         pinDelivery.geometry.setCoordinates(coords);
            //     } else {
            //         // Создаём новый пин
            //         pinDelivery = new globalThis.ymaps.Placemark(coords, {
            //         balloonContent: `Координаты: ${coords[0].toFixed(6)}, ${coords[1].toFixed(6)}`
            //         }, {
            //         draggable: true
            //         });
            //         map.geoObjects.add(pinDelivery);
            //     }
            //     const data = new DeliveryService_SearchDeliveryInfo_Request();
            //     data.pin = new Coordinates();
            //     data.pin.lat = coords[0];
            //     data.pin.lng = coords[1];
            //     data.tariffName = this._selectedTariff;
            //     let weightKg=0;
            //     for(const w of this._cartCtrl.getCart().map((p)=>{return p.count*p.weightKgPerLot})) weightKg+=w;
            //     data.weight = weightKg;
            //     const info = await this.app.gui.lockAction(this.app.api.deliveryService.searchDeliveryInfo(data));
            //     if (!info||!info?.isAvailable)
            //     {
            //         this._deliveryInfo=info;
            //         this._refreshTotalAsync();
            //         return;
            //     }
            //     globalThis.ymaps.geocode(coords).then((res) => {
            //     const firstGeoObject = res.geoObjects.get(0);
            //     if (firstGeoObject) {
            //         const address = firstGeoObject.getAddressLine();
            //         this.page.ctrls.iDeliveryAddress.value = address;
            //         this._deliveryAddress=address;
            //         this._deliveryInfo = info;
            //         this._deliveryPin = data.pin;
            //         this._refreshTotalAsync();
            //     }
            //     });
            //   });
            // Создаём компонент автоподсказки
            const suggestView = new globalThis.ymaps.SuggestView(this.page.ctrls.iDeliveryAddress.el);
            let state = this;
            // Обработка выбора подсказки
            suggestView.events.add('select', function (e) {
                state._deliveryAddress = e.get('item').value;
                state._geocodeAddressAsync();
            });
        });
    }
    _geocodeAddressAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            // Выполняем геокодирование по выбранному адресу
            globalThis.ymaps.geocode(this._deliveryAddress).then((res) => __awaiter(this, void 0, void 0, function* () {
                const geoObj = res.geoObjects.get(0);
                if (!geoObj) {
                    this._resetDeliveryDataAsync();
                    return;
                }
                this._deliveryAddress = geoObj.getAddressLine();
                this.page.ctrls.iDeliveryAddress.value = this._deliveryAddress;
                const coords = geoObj.geometry.getCoordinates();
                const house = geoObj.getPremiseNumber(); // номер дома
                if (!this._mapDeliveryPin) {
                    this._mapDeliveryPin = new globalThis.ymaps.Placemark(coords);
                    this._map.geoObjects.add(this._mapDeliveryPin);
                }
                else
                    this._mapDeliveryPin.geometry.setCoordinates(coords);
                if (!house) {
                    return;
                }
                const data = new models_1.DeliveryService_SearchDeliveryInfo_Request();
                data.pin = new models_1.Coordinates();
                data.pin.lat = coords[0];
                data.pin.lng = coords[1];
                data.tariffName = this._deliveryTariff;
                data.weight = this._cartCtrl.getCartWeight();
                this._deliveryPin = data.pin;
                const info = yield this.app.gui.lockAction(this.app.api.deliveryService.searchDeliveryInfo(data));
                //if (!info||!info?.isAvailable) {this._deliveryInfo = info; this._fillCartTotalAsync(); return;}
                this._deliveryInfo = info;
                this._fillCartTotalAsync();
            }));
        });
    }
    _tryCreateNewOrderAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._deliveryAddress)
                if (this._deliveryAddress != this.page.ctrls.iDeliveryAddress.value) {
                    this.page.ctrls.cmpCartTotal.ctrls.btnSubmit.disable();
                    return;
                }
            let items = [];
            let costTotal = 0;
            const data = new models_1.BusinessService_CreateOrder_Request();
            data.invoice.userName = this.page.ctrls.iName.value;
            data.invoice.userEmail = this.page.ctrls.iEmail.value;
            data.invoice.comment = this.page.ctrls.iComment.value;
            data.invoice.paymentType = models_1.OrderPaymentTypeEnum.Online;
            data.invoice.discounts = [];
            data.invoice.delivery = new models_1.OrderDelivery();
            data.invoice.delivery.type = models_1.OrderDeliveryTypeEnum.SelfPickup;
            data.invoice.delivery.price = 0;
            if (this._deliveryInfo && this._deliveryInfo.isAvailable) {
                data.invoice.delivery.type = models_1.OrderDeliveryTypeEnum.LocalDelivery;
                data.invoice.delivery.price = this._deliveryInfo.price;
                data.invoice.delivery.address = this._deliveryAddress;
                data.invoice.delivery.pin = this._deliveryPin;
                data.invoice.delivery.deliveryInfo = this._deliveryInfo;
                costTotal += this._deliveryInfo.price;
            }
            //TODO checkCost - должен быть строкой, т.к. decimal
            const cart = this._cartCtrl.getCart();
            for (const pos of cart) {
                const prod = yield this.app.cache.getProductAsync(pos.productId);
                if (!prod)
                    continue;
                const qty = this._cartCtrl.getQty(prod.id);
                costTotal += qty * prod.price;
                const item = new models_1.OrderInvoiceItem();
                item.amount = qty;
                item.productId = pos.productId;
                items.push(item);
            }
            data.invoice.checkCost = costTotal;
            data.invoice.items = items;
            const order = yield this.app.gui.lockAction(this.app.api.businessService.createOrder(data));
            if (!order)
                return;
            AppPM_1.AppPM.Cart.clear();
            this.page.ctrls.lOrderId_Created.text =
                this.page.ctrls.lOrderId_NeedConfirm.text =
                    this.page.ctrls.lOrderId_NeedPay.text = order.id + "";
            this.page.ctrls.blockDetails.hide();
            this.page.ctrls.blockOrderCreated.show();
            this._waitOrderStatus(order);
        });
    }
    _waitOrderStatus(order) {
        return __awaiter(this, void 0, void 0, function* () {
            let stop = false;
            while (true) {
                if (order.status == models_1.OrderStatusEnum.Created) {
                    const data = new models_1.BusinessService_AwaitOrderConfirmMasterSystemLP_Request();
                    data.orderId = order.id;
                    const update = yield this.app.api.businessService.awaitOrderConfirmMasterSystemLP(data, { skip: true, callback: (e) => {
                            if (!e) {
                                stop = true;
                                return;
                            } //TODO отпработка ошибки
                            if (e.code != 422) {
                                stop = true;
                                return;
                            }
                        } });
                    if (!update)
                        continue;
                    order = update;
                    continue;
                }
                else if (order.status == models_1.OrderStatusEnum.NeedPay) {
                    this.page.ctrls.blockOrderCreated.hide();
                    this.page.ctrls.blockOrderNeedPay.show();
                    const data = new models_1.BusinessService_AwaitOrderPaymentPendingLP_Request();
                    data.orderId = order.id;
                    const update = yield this.app.api.businessService.awaitOrderPaymentPendingLP(data, { skip: true, callback: (e) => {
                            if (!e) {
                                stop = true;
                                return;
                            } //TODO отпработка ошибки
                            if (e.code != 422) {
                                stop = true;
                                return;
                            }
                        } });
                    if (!update)
                        continue;
                    order = update;
                    document.location = order.paymentInfo.payment.paymentURL;
                    //TODO сделать проверку на статус и корректная отработка событий
                    return;
                }
                else {
                    this.page.ctrls.blockOrderCreated.hide();
                    this.page.ctrls.blockOrderNeedConfirm.show();
                    return;
                }
            }
        });
    }
    _fillDeliveryOptions(tariffBook) {
        const ctrls = this.page.ctrls;
        const options = [];
        const docClickHandler = (e) => {
            if (options.indexOf(e.target) < 0) {
                document.removeEventListener("click", docClickHandler);
                ctrls.optionsList.hide();
            }
        };
        ctrls.optionsSelected.onclick = (e) => {
            gs.events.stop(e);
            if (ctrls.optionsList.isShowed)
                return;
            ctrls.optionsList.show();
            document.addEventListener("click", docClickHandler);
        };
        ctrls.optionsList.html = '';
        for (const tariff of tariffBook.tariffs) {
            const option = gs.w(gs.html.div({ class: "option_item" }, tariff.name));
            ctrls.optionsList.append(option);
            options.push(option.el);
            option.onclick = () => __awaiter(this, void 0, void 0, function* () {
                yield this._resetDeliveryDataAsync();
                ctrls.optionsSelected.text = option.text;
                this._deliveryTariff = tariff.name;
                //TODO пересчет
                ctrls.optionsList.hide();
                document.removeEventListener("click", docClickHandler);
            });
        }
        if (options.length > 0)
            options[0].click();
    }
    _resetDeliveryDataAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this._deliveryInfo = undefined;
            this._deliveryAddress = "";
            this._deliveryPin = undefined;
            this.page.ctrls.iDeliveryAddress.value = '';
            yield this._fillCartTotalAsync();
            if (this._mapDeliveryPin) {
                this._map.geoObjects.remove(this._mapDeliveryPin);
                this._mapDeliveryPin = undefined;
            }
        });
    }
    _fillCartTotalAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            let costTotal = 0;
            let costDelivery = 0;
            const cart = this._cartCtrl.getCart();
            for (const pos of cart) {
                const prod = yield this.app.cache.getProductAsync(pos.productId);
                if (!prod)
                    continue;
                const qty = this._cartCtrl.getQty(prod.id);
                costTotal += qty * prod.price;
            }
            const cmpTotal = this.page.ctrls.cmpCartTotal;
            if (this.page.ctrls.blockGetDelivery.isShowed)
                cmpTotal.ctrls.btnSubmit.disable();
            else
                cmpTotal.ctrls.btnSubmit.enable();
            if (this._deliveryInfo) {
                cmpTotal.ctrls.blockDelivery.show();
                if (this._deliveryInfo.isAvailable) {
                    cmpTotal.ctrls.lCostDetailsDelivery.text = this._deliveryInfo.price + "₽";
                    cmpTotal.ctrls.btnSubmit.enable();
                    costDelivery = this._deliveryInfo.price;
                }
                else {
                    cmpTotal.ctrls.lCostDetailsDelivery.text = "Недоступно";
                }
            }
            else {
                cmpTotal.ctrls.blockDelivery.hide();
            }
            cmpTotal.ctrls.lCostTotal.text = Helper_1.Helper.toPriceString(costTotal + costDelivery);
            cmpTotal.ctrls.lCostDetailsTotal.text = Helper_1.Helper.toPriceString(costTotal);
            cmpTotal.ctrls.lCount.text = cart.length + "";
            cmpTotal.ctrls.blockDiscount.hide();
        });
    }
}
exports.StateOrderNew = StateOrderNew;
StateOrderNew.StateName = "new_order";
//# sourceMappingURL=StateOrderNew.js.map